export default {"src":"/_next/static/media/Orthopaedics.d7df8f4f.svg","height":91,"width":90,"blurWidth":0,"blurHeight":0};